$( document ).ready(function() {
jQuery('.3dhubs').click( threedeeHubs );

function threedeeHubs() {
  ga('send', 'event', {
    eventCategory: 'Button',
    eventAction: 'Click',
    eventLabel: 'Go to 3D Hubs'
  });
}
})

$( document ).ready(function() {
  jQuery('.add').click( addToCart );
  
  function addToCart() {
    ga('send', 'event', {
      eventCategory: 'Button',
      eventAction: 'Click',
      eventLabel: 'Add To Cart'
    });
  }
})

$( document ).ready(function() {
  jQuery('#checkout').click( checkout );
  
  function checkout() {
    ga('send', 'event', {
      eventCategory: 'Button',
      eventAction: 'Click',
      eventLabel: 'Checkout'
    });
  }
})

$( document ).ready(function() {

  jQuery('a[href$="pdf"]').click( pdfDownload )
  
  function pdfDownload() {
    ga('send', 'event', {
      
      eventCategory: 'Download',
      eventAction: 'Click',
      eventLabel: 'Download PDF'
    });
  }

})
$( document ).ready(function() {
jQuery('.newsletter-signup-submit').click( newsletterSignup );

function newsletterSignup() {
  ga('send', 'event', {
    eventCategory: 'Button',
    eventAction: 'Click',
    eventLabel: 'Newsletter Signup'
  });
}
})
